'use client';

import { useHomeEditor } from "@/app/features/sites/home/contexts/HomeContext";
import { Markdown } from "@/app/features/shared/markdown/Markdown";
import MarkdownEditor from "@/app/features/shared/editable-markdown/MarkdownEditor";
import { Stack } from "@mui/material";
import IntroAnchor from "@/app/features/shared/__to_be_integrated/ui/IntroAnchor";
import { HomeIntroFrame } from "@/app/features/sites/home/ui/shared/HomeViewFrames";
import { useState } from "react";
import InlineEditingButton from "@/app/features/shared/buttons/InlineEditingButton";

export default function HomeIntro() {
    const { editable, updateEditable } = useHomeEditor();
    const [isEditingIntro, setIsEditingIntro] = useState(false);

    if (!editable) return null;

    const introText = editable.intro || '';

    return (
        <>
            <IntroAnchor />
            <HomeIntroFrame>
                <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
                    <InlineEditingButton isEditing={isEditingIntro} setIsEditing={setIsEditingIntro} />
                </Stack>
                {isEditingIntro ? (
                    <MarkdownEditor
                        value={introText}
                        onChange={(intro) => updateEditable({ intro })}
                        typographyOverrides={{ paragraph: "body2" }}
                        slots={{ root: { sx: { textAlign: 'center' } } }}
                    />
                ) : (
                    <Markdown
                        value={introText}
                        slots={{
                            root: {
                                textAlign: 'center'
                            }
                        }}
                    />
                )}
            </HomeIntroFrame>
        </>
    );
}
